import * as React from 'react';
import PropTypes from 'prop-types';
import {
    withStyles, Typography, Avatar, ButtonBase,
} from '@material-ui/core';
import { Translate } from 'react-localize-redux';
import classnames from 'classnames';

import VimoLink from './VimoLink';
import VimoModal from './VimoModal';

import {
    EditIcon, InfoIcon, AddIcon,
} from '../icons';
import { Image } from '../../youwell-common/components';
import { green3 } from '../../app/style/theme';

const styles = theme => ({
    root: {
        minHeight: 100,
        background: theme.colors.grey2,
        padding: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
    },
    heading: {
        padding: theme.spacing(1),
        textTransform: 'uppercase',
    },
    main: {
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(1),
        marginBottom: theme.spacing(1),
        minHeight: 100,
    },
    mainText: {
        display: 'flex',
        alignItems: 'center',
    },
    childContent: {
        marginTop: theme.spacing(1),
    },
    mainIcon: {
        marginRight: theme.spacing(1),
        fontSize: theme.sizes.largeIcon,
    },
    hideIconOnSmall: {
        [theme.breakpoints.only('sm')]: {
            display: 'none',
        },
    },
    mainAvatar: {
        marginRight: theme.spacing(1),
        background: theme.colors.blue4,
        color: theme.palette.common.white,
        fontSize: theme.sizes.largeAvatar,
    },
    primary: {
    },
    primaryReduced: {
        fontSize: theme.sizes.reducedH5FontSize,
    },
    secondary: {
        textTransform: 'uppercase',
    },
    footer: {
        height: theme.spacing(5),
        padding: theme.spacing(1),
        display: 'flex',
        justifyContent: 'flex-end',
        margin: -theme.spacing(1),
        background: theme.colors.grey1,
    },
    editIcon: {
        marginRight: theme.spacing(1),
    },
    infoIcon: {

    },
    flex: {
        flex: '1 1 auto',
    },
});

const MODAL_TYPES = {
    EDIT: 'EDIT',
    ADD: 'ADD',
    INFO: 'INFO',
};

class InfoBox extends React.Component {
    state = {
        showModal: null,
    }

    showModal = type => () => {
        this.setState({
            showModal: type,
        });
    }

    closeModal = () => {
        this.setState({
            showModal: null,
        });
    }

    renderModal = () => {
        const {
            EditContent, InfoContent, EditContentProps,
            InfoContentProps,
            AddContent, AddContentProps,
        } = this.props;

        switch (this.state.showModal) {
        case MODAL_TYPES.ADD:
            return (<AddContent onClose={this.closeModal} {...AddContentProps} />);
        case MODAL_TYPES.EDIT:
            return (<EditContent onClose={this.closeModal} {...EditContentProps} />);
        case MODAL_TYPES.INFO:
            return (<InfoContent onClose={this.closeModal} {...InfoContentProps} />);
        default:
            return null;
        }
    }

    renderModalHeading = () => {
        const {
            EditContentHeader,
            InfoContentHeader,
            AddContentHeader,
        } = this.props;

        switch (this.state.showModal) {
        case MODAL_TYPES.ADD:
            return AddContentHeader || <Translate id="infobox.add" />;
        case MODAL_TYPES.EDIT:
            return EditContentHeader || <Translate id="infobox.editDetails" />;
        case MODAL_TYPES.INFO:
            return InfoContentHeader || <Translate id="infobox.info" />;
        default:
            return null;
        }
    }

    render() {
        const {
            classes, className, heading, Icon, primary, secondary, link, color, simpleIcon, children, hideIconOnSmall,
            EditContent, InfoContent, AddContent, bigText, disabled, image, ModalProps,

        } = this.props;

        const textColor = color && color !== green3 ? 'white' : null;

        return (
            <div className={classnames(classes.root, className)}>
                <Typography variant="caption" className={classes.heading}>
                    { heading }
                </Typography>
                <div className={classes.main}>
                    <div className={classes.mainText}>
                        {image && <Image src={image} className={classnames(classes.mainIcon, { [classes.hideIconOnSmall]: hideIconOnSmall })} />}
                        {Icon && <Icon className={classnames(classes.mainIcon, { [classes.hideIconOnSmall]: hideIconOnSmall })} color="secondary" />}
                        {simpleIcon && primary && <Avatar className={classes.mainAvatar} style={{ background: color }}>{primary.slice(0, 1)}</Avatar>}
                        <div>
                            {primary && (
                                <Typography variant="h5" className={classnames(classes.primary, { [classes.primaryReduced]: !bigText })}>
                                    {primary}
                                </Typography>
                            )}
                            {secondary && (
                                <Typography variant="caption" className={classes.secondary}>
                                    {secondary}
                                </Typography>
                            )}
                        </div>
                    </div>
                    {children && (
                        <div className={classes.childContent}>
                            {children}
                        </div>
                    )}
                </div>
                <div className={classes.footer} style={{ background: color }}>
                    {InfoContent && (
                        <ButtonBase onClick={this.showModal(MODAL_TYPES.INFO)} disabled={disabled} style={{ opacity: disabled ? 0.5 : undefined }} className={classes.infoIcon}>
                            <InfoIcon color="secondary" style={{ color: textColor }} />
                        </ButtonBase>
                    )}
                    <div className={classes.flex} />
                    {link && <VimoLink to={link.to} text={link.text} forward white={!!textColor} />}
                    {EditContent && (
                        <ButtonBase onClick={this.showModal(MODAL_TYPES.EDIT)} disabled={disabled} style={{ opacity: disabled ? 0.5 : undefined }}>
                            <EditIcon color="secondary" style={{ color: textColor }} className={classes.editIcon} />
                            <Typography className={classes.linkText} style={{ color: textColor }}>
                                <span className={classes.underline}>
                                    <Translate id="infobox.edit" />
                                </span>
                            </Typography>
                        </ButtonBase>
                    )}
                    {AddContent && (
                        <ButtonBase onClick={this.showModal(MODAL_TYPES.ADD)} disabled={disabled} style={{ opacity: disabled ? 0.5 : undefined }}>
                            <AddIcon color="secondary" style={{ color: textColor }} className={classes.editIcon} />
                            <Typography className={classes.linkText} style={{ color: textColor }}>
                                <span className={classes.underline}>
                                    <Translate id="infobox.add" />
                                </span>
                            </Typography>
                        </ButtonBase>
                    )}
                </div>

                <VimoModal
                    open={!!this.state.showModal}
                    onClose={this.closeModal}
                    heading={this.renderModalHeading()}
                    {...ModalProps}
                >
                    {
                        this.renderModal()
                    }
                </VimoModal>
            </div>
        );
    }
}

InfoBox.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    heading: PropTypes.string,
    Icon: PropTypes.object,
    primary: PropTypes.string,
    secondary: PropTypes.string,
    link: PropTypes.object,
    color: PropTypes.string,
    simpleIcon: PropTypes.bool,
    hideIconOnSmall: PropTypes.bool,
    EditContent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    EditContentProps: PropTypes.object,
    EditContentHeader: PropTypes.string,
    InfoContent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    InfoContentProps: PropTypes.object,
    InfoContentHeader: PropTypes.string,
    AddContent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    AddContentProps: PropTypes.object,
    AddContentHeader: PropTypes.string,
    bigText: PropTypes.bool,
    disabled: PropTypes.bool,
    image: PropTypes.string,
    ModalProps: PropTypes.object,
};

InfoBox.defaultProps = {
    children: null,
    className: null,
    heading: null,
    Icon: null,
    primary: null,
    secondary: null,
    link: null,
    color: null,
    simpleIcon: false,
    hideIconOnSmall: false,
    EditContent: null,
    AddContent: null,
    InfoContent: null,
    EditContentProps: null,
    EditContentHeader: null,
    AddContentProps: null,
    AddContentHeader: null,
    InfoContentProps: null,
    InfoContentHeader: null,
    bigText: false,
    disabled: false,
    image: null,
    ModalProps: null,
};

export default withStyles(styles)(InfoBox);
